module.exports = __webpack_public_path__ + "img/46a-mensagens-recebidas-leitura.93265c9a.png";